/**
 * map モジュール
 * - 地図
 */
export const MAP = {
  init() {
    const voiceMap = document.querySelector('.js-voice-map')
    if (voiceMap) {
      // ピンの個数
      const PIN_COUNT = 7

      for (let i = 0; i < PIN_COUNT; i += 1) {
        const selector = `.p-clients__popup-item.is-rank${i + 1}`

        setTimeout(() => {
          const popups = voiceMap.querySelectorAll(selector)
          popups.forEach(popup => {
            popup.classList.add('is-active')
          })
        }, 100 * i + 1)
      }

      // スマホ版
      // document.querySelectorAll('.p-voice-map__popup--sp').forEach(popup => {
      //   popup.classList.add('is-active')
      // })
    }

    // カウントアップ
    const countEl = document.querySelector('.js-voice-count')
    if (countEl) {
      const target = Number.parseInt(countEl.dataset.count, 10)
      if (Number.isNaN(target)) return

      const digitLen = String(target).length
      const step = Math.max(1, Math.floor(target / 20))
      const speed = 50

      const countEm = countEl.querySelector('em')
      if (!countEm) return

      let current = 0

      const timer = window.setInterval(() => {
        if (current < target) {
          countEm.textContent = current
          current += step
        } else {
          countEm.textContent = String(target).padStart(digitLen, '0')
          window.clearInterval(timer)
        }
      }, speed)
    }
  },
}
